import type { PriceImprovementRejectRequest } from 'apiConnector/price-improvement';
import { priceImprovementApi } from 'apiConnector/price-improvement';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import {
  priceImprovementRejectFailed,
  priceImprovementRejectSucceded,
} from 'state/quotes/priceEnhancements/priceImprovementResponse/priceImprovementResponse.actions';
import type { EpicWithThunk } from 'state/state.common';
import * as apiErrorHelper from 'utils/http/apiErrorHelper';

export function priceImprovementRejectEpic(): EpicWithThunk {
  return (action$, state$, { httpClient }) =>
    action$.pipe(
      ofType('PRICE_IMPROVEMENT_REJECTED'),
      withLatestFrom(state$),
      mergeMap(([{ requestForPriceImprovementId, comment }]) => {
        const request: PriceImprovementRejectRequest = {
          comment,
        };
        return priceImprovementApi(httpClient)
          .reject(requestForPriceImprovementId, request)
          .pipe(
            map(() => priceImprovementRejectSucceded(requestForPriceImprovementId)),
            catchError(error => {
              return of(priceImprovementRejectFailed(requestForPriceImprovementId, apiErrorHelper.toApiError(error)));
            }),
          );
      }),
    );
}
